






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore
import KUTE from 'kute.js';

import { Gradient } from '@/components/wobble/model';

@Component
export default class FloatingWobble extends Vue {
  @Prop({ required: true }) readonly pathA!: string;
  @Prop({ required: true }) readonly pathB!: string;
  @Prop({ required: true }) readonly gradient!: Gradient;
  @Prop({ required: true }) readonly scale!: number;
  @Prop({ required: true }) readonly duration!: number;
  @Prop({ required: true }) readonly freeze!: boolean;
  @Prop({ required: true }) readonly visible!: boolean;
  @Prop({ required: true }) readonly wobbleId!: string;

  public path = '';
  private tween: any;

  created() {
    this.path = this.pathA;
  }

  mounted() {
    this.tween = KUTE.to(
      '#floating-wobble-path' + this.wobbleId,
      {
        path: this.pathB,
      },
      {
        morphPrecision: 0.0000001,
        duration: this.duration,
        easing: 'easingSinusoidalInOut',
        yoyo: true,
        repeat: 99999,
        complete: () => {
          if (this.freeze) return;
          // todo loop here?
        }
      }
    );
    if (!this.freeze) {
      this.tween.start();
    }
  }

  @Watch('freeze', {
    immediate: true
  })
  watchFreeze() {
    if (!this.tween) return;

    if (this.freeze) {
      this.tween.pause();
      return;
    }
    this.tween.start();
  }
}
